<script lang="ts">
    import { createEventDispatcher, onMount } from "svelte";
    import { Button, Icon } from "sveltestrap";
    import { croquis, clearCanvas, saveCanvas } from "../utils/croquis";
  
    const dispatch = createEventDispatcher();

    let width = 200;

    onMount(() => {
      croquis();
      
    });

    function savePng(){
      let png = saveCanvas()
      dispatch('savePngSign', png)
    }

  </script>
  
  <div bind:clientWidth={width} class="canvas-container">
    <canvas id="sig-canvas" class="sig-canvas-css" height="250" {width} />
  </div>
  
  <div class="w-full flex mt-2">
    <Button color="warning" on:click={clearCanvas}>
      <Icon name="eraser-fill" /> <span class="ml-2">Borrar</span>  
    </Button>

    <Button color="primary" on:click={savePng}>
      <Icon name="vector-pen" /> <span class="ml-2">Firmar</span> 
    </Button>
</div>


<style>
  :global(.sig-canvas-css) {
    border: 2px dotted #cccccc;
    border-radius: 15px;
    cursor: crosshair;
  }

  .canvas-container{
    max-width: 500px;
  }
</style>
  